import { render, staticRenderFns } from "./InboxTable.vue?vue&type=template&id=05bbecc9&scoped=true&"
import script from "./InboxTable.vue?vue&type=script&lang=ts&"
export * from "./InboxTable.vue?vue&type=script&lang=ts&"
import style0 from "./InboxTable.vue?vue&type=style&index=0&id=05bbecc9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bbecc9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCardText,VCardTitle,VCol,VIcon,VRow})
